export default __webpack_public_path__ + "static/media/40172.1ade35c9.jpg";